import { useState, useCallback } from 'react';

export function useNavigation(initialPage = 'role') {
  const [page, setPage] = useState(initialPage);
  const [history, setHistory] = useState([initialPage]);
  const [currentSection, setCurrentSection] = useState(null);

  const navigate = useCallback((targetPage, sectionKey = null) => {
    setHistory(prev => [...prev, targetPage]);
    setPage(targetPage);
    if (sectionKey !== undefined) setCurrentSection(sectionKey);
    window.scrollTo(0, 0);
  }, []);

  const goBack = useCallback(() => {
    setHistory(prev => {
      if (prev.length <= 1) return prev;
      const newHistory = prev.slice(0, -1);
      const prevPage = newHistory[newHistory.length - 1];
      setPage(prevPage);
      if (prevPage !== 'section') setCurrentSection(null);
      window.scrollTo(0, 0);
      return newHistory;
    });
  }, []);

  const goTo = useCallback((targetPage, sectionKey = null) => {
    navigate(targetPage, sectionKey);
  }, [navigate]);

  return { page, currentSection, navigate, goBack, goTo, setCurrentSection };
}
